import {IExportMessageQueue} from '../Interfaces/ExportMessageQueue';
import {AxiosConfig} from "./AxiosConfig/AxiosConfig";

const exportFeedbacks = async (id: string): Promise<any> => {
    return new Promise<any>((resolve, reject) => {
        return AxiosConfig.instance.get(`/feedbacks/${id}/exports`).then(response => {
            const contentType = response.headers["content-type"] ?? "text/plain";
            const base64File = `data:${contentType};base64,${response.data}`;
            fetch(base64File).then(res => res.blob()).then(blob => resolve(blob));
        }).catch(error => {
            reject(error);
        });
    });
}

const getTotalFeedbackDistinctUserId = async (id: string): Promise<number> => {
    return new Promise<number>((resolve, reject) => {
        return AxiosConfig.instance.get(`/feedbacks/${id}/counts`).then(res => {
            return resolve(res.data);
        }).catch(error => {
            reject(error);
        });
    });
}

const FeedbackApi = {
    exportFeedbacks,
    getTotalFeedbackDistinctUserId,
}

export default FeedbackApi;